import React from "react";
import lazyPage from "../../../common/helpers/lazyPage";
import PageLoader from "../../components/PageLoader";

export default lazyPage(
    "src/front/articles/meta-data/meta-data.tsx",
    () => import("./meta-data"),
    <PageLoader />,
);
